webpackJsonp([188024569945456],{

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _seo = __webpack_require__(38);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _seo3 = __webpack_require__(44);
	
	var _seo4 = _interopRequireDefault(_seo3);
	
	var _registerNowLeft = __webpack_require__(23);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Seo = function (_React$Component) {
		(0, _inherits3.default)(Seo, _React$Component);
	
		function Seo() {
			(0, _classCallCheck3.default)(this, Seo);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Seo.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Seo.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
		};
	
		Seo.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Freelance Academic Writing Jobs - UvoCorp.com",
					meta: [{ name: "description", content: "Freelance academic writing jobs, writing careers. Apply for a job online with UvoCorp.com. Registration is free." }, { property: 'og:title', content: "Freelance Academic Writing Jobs - UvoCorp.com" }, { property: 'og:description', content: "Freelance academic writing jobs, writing careers. Apply for a job online with UvoCorp.com. Registration is free." }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/freelance_writing_jobs.html" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Freelance Academic Writing Jobs"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-benefits home-block hiring-benefits" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"The benefits you enjoy working as a freelance writer:"
							),
							_react2.default.createElement(
								"ul",
								{ className: "home-benefits-list" },
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-1" },
									_react2.default.createElement(
										"p",
										null,
										"No registration fees"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-2" },
									_react2.default.createElement(
										"p",
										null,
										"High wages"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-3" },
									_react2.default.createElement(
										"p",
										null,
										"Working from home"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-4" },
									_react2.default.createElement(
										"p",
										null,
										"Orders in the sphere ",
										_react2.default.createElement("br", null),
										"of your interest"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-5" },
									_react2.default.createElement(
										"p",
										null,
										"24/7 available ",
										_react2.default.createElement("br", null),
										"support team"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-6" },
									_react2.default.createElement(
										"p",
										null,
										"Payments always ",
										_react2.default.createElement("br", null),
										"on time"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-7" },
									_react2.default.createElement(
										"p",
										null,
										"Manage your time ",
										_react2.default.createElement("br", null),
										"and workload yourself"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-pricing-info" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"p",
								null,
								"There is no other company that offers ",
								_react2.default.createElement(
									"strong",
									null,
									"$15"
								),
								"/page written by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ESL"
								),
								" writer and ",
								_react2.default.createElement(
									"strong",
									null,
									"$26"
								),
								"/page completed by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ENL"
								),
								" writer."
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/prices.html" },
								"View Pricing ",
								_react2.default.createElement(
									"svg",
									{ id: "arrow-right", width: "22", height: "22" },
									_react2.default.createElement("path", { fill: "#black", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white hiring seo" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								null,
								"Writers wanted"
							),
							_react2.default.createElement(
								"div",
								{ className: "row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-9" },
									_react2.default.createElement(
										"p",
										null,
										"Dear potential ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UVOCORP"
										),
										" writers, we are currently hiring:"
									),
									_react2.default.createElement(
										"ol",
										{ className: "hiring-steps" },
										_react2.default.createElement(
											"li",
											null,
											"Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);"
										),
										_react2.default.createElement(
											"li",
											null,
											"English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;"
										),
										_react2.default.createElement(
											"li",
											null,
											"Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:"
										)
									),
									_react2.default.createElement(
										"ul",
										{ className: "hiring-disciplines" },
										_react2.default.createElement(
											"li",
											{ className: "discipline_8" },
											"Accounting"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_15" },
											"Architecture, Building and Planning"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_14" },
											"Biology (and other Life Sciences)"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_13" },
											"Chemistry"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_1" },
											"Engneering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_10" },
											"Civil Engineering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_7" },
											"Computer Science"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_5" },
											"IT, Web"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_3" },
											"Finance"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_11" },
											"Mathematics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_12" },
											"Physics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_4" },
											"Statistics"
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "hiring-img" },
									_react2.default.createElement("img", { src: _seo4.default, alt: "Seo Image" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "row seo-row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-4 seo-img-container" },
									_react2.default.createElement(
										"div",
										{ className: "seo-img" },
										_react2.default.createElement("img", { src: _seo2.default, alt: "Seo Image" })
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-md-8" },
									_react2.default.createElement(
										"p",
										null,
										"Freelance academic writing has become a highly competitive market online, creating rivalry for writers seeking employment. When you want to be a successful freelance writer, you can spend hours, days, and weeks searching through all the options available online, trying to find the perfect one, which suits you best and pays what you deserve. At UVOCorp, we have freelance academic writing jobs within the pay ranges you need. Our rates are better than those of most organizations, and they are convenient jobs you can take, as you need them, or decline if you are busy with other orders and responsibilities."
									),
									_react2.default.createElement(
										"h2",
										{ className: "inner-left-intext" },
										"We need writers, successful freelance writers, for our freelance writing jobs."
									),
									_react2.default.createElement(
										"p",
										null,
										"We seek dedicated writers, eager to work online, to produce high quality work for our customers. If you are a freelance writer who is tired of all the headaches, hassles, and low pay, you need our freelance organization, where you can get the pay you want. You deserve to accomplish your goals of increasing your writing income, and with our freelance academic writing jobs, you can reach these goals successfully. The rates we pay to our freelance writers is very competitive, and substantially more than mere pennies per word. What\u2019s more, we provide you with work in the disciplines you are interested in and qualified to work on."
									),
									_react2.default.createElement(
										"p",
										null,
										"Here at ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UVOCorp"
										),
										", we are dedicated to providing the opportunities you deserve. Our owners and administrators are very familiar with the difficulty of writing successfully on a daily basis, and are familiar with the amount of work that goes into the projects, which is why we pay more. Many organizations pay writers on some standard that is completely unrelated to the actual work that goes into writing, work they themselves could not execute, nor have completed successfully before. Our leaders have worked on similar projects, and are very familiar with the difficulty involved. At UVOCorp, we understand the time you have dedicated to becoming a successful writer, and we pay what you deserve when you write for our organization. Our goals are to meet the needs of our customers, by supplying work from professional writers able to consistently meet the high standards they demand. You are the key to attaining our objectives \u2013 high customer satisfaction, industry leadership, and reliable service."
									),
									_react2.default.createElement(
										"p",
										null,
										"Freelance academic writing jobs allow you to have a flexible schedule, with the benefits of pay based on performance, and bonuses. I If you are an active freelance writer, you can increase your income by writing papers for our services in your free time. We value your time, we understand your effort, and we are pay fair wages that meet competitive standards for all our freelance academic writing jobs. Your needs meet our needs \u2013 you need pay commensurate with your effort, and we need writers who value our customers. If you seek a freelance academic writing job, visit us today and sign up for the best paying ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"freelance writing"
										),
										" vacancies online."
									),
									_react2.default.createElement(
										"p",
										null,
										"Many professional freelance writers are looking for writing opportunities that enable personal growth and achievement. With us, you get the best academic writing jobs at rates that make freelancing successful and productive for your needs. Freelance academic writing jobs do not have to be cheap projects that pay you very little for your time. You are looking for the best freelancing job to cover your expenses and provide you with opportunities to grow as a writer; you can join our strong staff of freelance writers and accomplish your goals"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Seo;
	}(_react2.default.Component);
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-freelance-writing-jobs-html-js-8bb4b925b022a5809ade.js